const filterSlider = () => {
  const filterableSliders = document.querySelectorAll(
    '.js-slider-filter[data-id]',
  )

  if (filterableSliders) {
    Array.from(filterableSliders).forEach((el) => {
      $(el).on('change', (e) => {
        const selectedLocation = e.target.value

        var slider = $(el).find('.slick-slider')

        slider.slick('slickUnfilter')

        if (selectedLocation) {
          var selector = '[data-locations*="' + selectedLocation + '"]'
          slider.slick('slickFilter', selector)
        }
      })
    })
  }
}

export default filterSlider
